import {environment} from '../../environments/environment';
import {AuthHttp, AuthConfig} from 'angular2-jwt';
import {Http, RequestOptions, URLSearchParams} from '@angular/http';
import {Interpreter, User} from './model/user.entity';
import * as moment from 'moment';
import { ReplaySubject } from 'rxjs/ReplaySubject';

export interface ModalOptions {
    cancelTitle: string;
    okTitle: string;
    closeVal: string;
}
/* Change this class to use Using Application Providers import { Data } from "../../providers/data/data" */
export class GLOBAL {
    public static MOCK_BOOKING_SERVER_PORT = 1233;
    public static MOCK_USER_SERVER_PORT = 1234;
    public static RAILS_LOCAL_SERVER_PORT = 3000;
    public static uPageNumber = 1;
    public static userPageSize = '10';
    public static bookingPageNumber = 1;
    public static bookingPageSize = '10';
    public static userPaginationSizeField= 'userPaginationSizeField';
    public static bookingPaginationSizeField= 'bookingPaginationSizeField';

    public static BOOKING_JOB_INVITE =
      (/^auslan-canary-.*.now.sh$/.test(window.location.host)
        ? 'http://auslan-booking-system-ct.s3-website-ap-southeast-2.amazonaws.com'
        : window.location.protocol + '//' + window.location.host) + '/#/booking-management/';

    public static LOG_LEVEL = 'INFO';
    public static USER_API_ENDPOINT = (environment.stage) ? 'https://auslan-staging.herokuapp.com/api/v1'
        : (environment.canary) ? 'https://auslan.herokuapp.com/api/v1' :
            (environment.localhost) ? `http://localhost:${GLOBAL.RAILS_LOCAL_SERVER_PORT}/api/v1` :
                (environment.test) ? `https://auslan-e2e-testing.herokuapp.com/api/v1` :
                    (environment.production) ? 'https://api.auslanconnections.com/api/v1' :
                    `http://localhost:${GLOBAL.MOCK_USER_SERVER_PORT}/api/v1`;
    public static BOOKING_API_ENDPOINT = (environment.stage) ? 'https://auslan-staging.herokuapp.com/api/v1'
        : (environment.canary) ? 'https://auslan.herokuapp.com/api/v1' :
            (environment.localhost) ? `http://localhost:${GLOBAL.RAILS_LOCAL_SERVER_PORT}/api/v1` :
                (environment.test) ? `https://auslan-e2e-testing.herokuapp.com/api/v1` :
                    (environment.production) ? 'https://api.auslanconnections.com/api/v1' :
                    `http://localhost:${GLOBAL.MOCK_BOOKING_SERVER_PORT}/api/v1`;
    public static USER_API = GLOBAL.USER_API_ENDPOINT + '/users';
    public static USER_APPI = GLOBAL.USER_API_ENDPOINT;

    public static BOOKING_API = GLOBAL.BOOKING_API_ENDPOINT + '/bookings';
    public static ORGANISATION_API = GLOBAL.BOOKING_API_ENDPOINT + '/organisations';
    public static TITLE = 'Auslan Connections';
    public static VERSION = '+'; // This should be broken into MAJOR and MINOR version?
    private static _currentUser: any;
    private static _currentUserSubject = new ReplaySubject<User>(1);
    static readonly currentUser$ = GLOBAL._currentUserSubject.asObservable();
    private static _interpreter: Interpreter;
    public static FAKE_TOKEN = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.' +
        'eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE0ODgxOTM0MTAsImV4cCI6MzMwNzY2M' +
        'zgyMTAsImF1ZCI6Ind3dy5wYWN0LmNvbSIsInN1YiI6Imthcm1hQHBhY3QuY29tIn0.lVWLJAYQRZcQTMtdDrxTHMwboSOqNQPISLDAKDkPy58';
    public static DSQ_STATES = ['ACT', 'NSW', 'QLD', 'NT', 'AUSTRALIAN\ CAPITAL\ TERRITORY', 'NEW\ SOUTH\ WALES', 'NORTHERN\ TERRITORY', 'QUEENSLAND'];
    public static VICDEAF_STATES = ['VIC', 'TAS', 'SA', 'WA', 'SOUTH\ AUSTRALIA', 'TASMANIA', 'VICTORIA', 'WESTERN\ AUSTRALIA'];
    public static GPO_ADDRESS_ONE = '350 Bourke Street, Melbourne VIC, 3000, Australia';
    public static GPO_ADDRESS_TWO = '261 Queens Street, Brisbane City QLD, 4000, Australia';
    public static MISSING_FIELDS_ERROR_MESSAGE = 'Oops! Please fill in all the fields correctly.';
    public static MISSING_SECTION_FIELDS_ERROR_MESSAGE = 'Please complete all sections on the page.';
    public static userStatusArray = [{name: 'Active'}, {name: 'Disabled'}];
    private static _extRefVal: URLSearchParams = new URLSearchParams();
    public static _filterVal: URLSearchParams = new URLSearchParams();
    public static _filterInterpreterVal: URLSearchParams = new URLSearchParams();
    public static _filterUserVal: URLSearchParams = new URLSearchParams();
    public static oldSearchParameter: URLSearchParams = new URLSearchParams();
    public static activeFilter = 'all';
    // UI Params
    public static selBookingID = '';
    public static getExternalReferenceSearchValue() {
      return GLOBAL._extRefVal.get('search');
    }
    public static setExternalReferenceSearchValue(val) {
      GLOBAL._extRefVal.set('search', val);
    }
  public static isExternalReferenceSearchValueExists() {
    return GLOBAL._extRefVal.has('search');
  }
    public static getSearchParameter() {
        let p = new URLSearchParams();
        this._extRefVal.paramsMap.forEach((value: string[], key: string) => {
            for (let v of value) {
                p.set(key, v);
            }
        });
        this._filterVal.paramsMap.forEach((value: string[], key: string) => {
            for (let v of value) {
                p.set(key, v);
            }
        });
        return p;
    }

    public static getInterpreterSearchParameters() {
        let p = new URLSearchParams();
        this._filterInterpreterVal.paramsMap.forEach((value: string[], key: string) => {
            for (let v of value) {
                p.set(key, v);
            }
        });
        return p;
    }

    public static getUserSearchParameters() {
        let p = new URLSearchParams();
        this._filterUserVal.paramsMap.forEach((value: string[], key: string) => {
            for (let v of value) {
                p.set(key, v);
            }
        });
        return p;
    }

    public static get currentUser(): any {
        return this._currentUser;
    }

    public static set currentUser(user: any) {
        this._currentUser = user;
        this._currentUserSubject.next(user);
    }

    public static get currentInterpreter(): Interpreter {
        return this._interpreter;
    }

    public static set currentInterpreter(interpreter: Interpreter) {
        this._interpreter = interpreter;
    }
    static fixDateFormat(d: Date) {

        let dateStr = d.toString();
        dateStr = dateStr.substr(6, 4) +
            '-' + dateStr.substr(3, 2) +
            '-' + dateStr.substr(0, 2);

        return new Date(dateStr);

    }
    public static calculateDaysAgo(created_at, start_time) {
        let createdDate = moment(new Date(created_at)).startOf('day');
        let bookingDate = moment(new Date(start_time)).startOf('day');
        return bookingDate.diff(createdDate, 'days');
    }
}

export function authService(http: Http, options: RequestOptions) {
    return new AuthHttp(new AuthConfig({
        tokenName: 'jwt',
        noJwtError: true,
        tokenGetter: (() => localStorage.getItem('token')),
        globalHeaders: [{'Content-Type': 'application/json'}],
    }), http, options);
};



// WEBPACK FOOTER //
// ./src/app/shared/global.ts